<template>
  <div>
    <!--<common-header />-->
    <main>
      <el-tabs
        v-model="selectedTitle"
        type="border-card"
        stretch
        @tab-click="handleCommand"
      >
        <el-tab-pane key="1" name="账户信息">
          <div slot="label" class="tab-item">
            <span class="el-icon-user-solid icon" />
            <span class="text">{{ $t("sampleApply.accountInfo.self") }}</span>
          </div>

          <div class="info common_class">
            <div class="user-basic-info">
              <span>{{ $t("sampleApply.accountInfo.baseInfo") }}</span>
              <span
                >{{ $t("sampleApply.accountInfo.username") }}:
                {{ username }}</span
              >
              <!--              <br>-->
              <!--              <span>手机号: </span>-->
            </div>
            <el-divider />
            <div class="user-address-list">
              <span>{{ $t("sampleApply.accountInfo.addressList") }}</span>
              <UserAddressList />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane key="2" name="样品申请">
          <div slot="label" class="tab-item">
            <span class="el-icon-box icon" />
            <span class="text">{{ $t("sampleApply.sampleApply.self") }}</span>
          </div>

          <div class="sample common_class">
            <div class="spl-title">
              <div class="text">
                {{ $t("sampleApply.sampleApply.availableNum") }}
              </div>
              <div class="num" style="">
                {{ sampleTotal }}
              </div>
            </div>

            <div class="search-box">
              <el-input
                v-model="searchKey"
                :placeholder="$t('sampleApply.sampleApply.searchPlaceholder')"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchSample"
                />
              </el-input>
            </div>

            <el-table :data="sampleData">
              <el-table-column :label="$t('sampleApply.sampleApply.partNo')">
                <template slot-scope="scope">
                  <el-link :href="'/productDetail?id=' + scope.row.id">
                    {{ scope.row["产品型号"] }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column :label="$t('sampleApply.sampleApply.category')">
                <template slot-scope="scope">
                  <div>
                    {{
                      $translate(scope.row["产品类别"], scope.row["产品类别"])
                    }}
                  </div>
                </template>
              </el-table-column>
              <!--              <el-table-column-->
              <!--                label="同等规格型号"-->
              <!--                prop=""-->
              <!--              >-->
              <!--                <template slot-scope="scope">-->
              <!--                  <div-->
              <!--                    v-for="(item, index) in scope.row['原厂替换']"-->
              <!--                    :key="index"-->
              <!--                    style="margin: 0 10px 0 10px"-->
              <!--                  >-->
              <!--                    <el-tag style="margin-right: 10px">-->
              <!--                      {{ item['原厂品牌'] }}-->
              <!--                    </el-tag>-->
              <!--                    <span>{{ item['原厂型号'] }}</span>-->
              <!--                  </div>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column
                :label="$t('sampleApply.sampleApply.operation')"
                width="400px"
              >
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.num"
                    size="small"
                    :min="1"
                    :max="20"
                    placeholder="≤ 20"
                    style="margin-right: 10px"
                  />
                  <el-button
                    icon="el-icon-shopping-cart-1"
                    circle
                    @click="addToCart(scope.row['产品型号'], scope.row.num)"
                  />
                </template> </el-table-column
              >>
            </el-table>
            <el-pagination
              layout="prev, pager, next, jumper"
              :total="sampleTotal"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane key="3" name="我的购物车">
          <div slot="label" class="tab-item">
            <span class="el-icon-shopping-cart-1 icon" />
            <span class="text">{{ $t("sampleApply.cart.self") }}</span>
          </div>

          <div class="cart common_class">
            <div>
              <el-table
                ref="multipleTable"
                :data="cartData"
                max-height="500px"
                @select="selectChangeCarts"
                @select-all="selectAllCarts"
                @selection-change="selectionLineChangeHandle"
              >
                <el-table-column type="selection" width="55" />
                <el-table-column
                  :label="$t('sampleApply.cart.partNo')"
                  prop="partNo"
                />
                <el-table-column :label="$t('sampleApply.cart.category')">
                  <template slot-scope="scope">
                    <div>
                      {{ $translate(scope.row.category, scope.row.category) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('sampleApply.cart.quantity')">
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.amount"
                      size="small"
                      :min="1"
                      :max="20"
                      placeholder="≤ 20"
                      style="margin-right: 10px"
                      @change="updateSampleCart(scope.row, false)"
                    />
                  </template>
                </el-table-column>
                <el-table-column :label="$t('sampleApply.cart.operation')">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-delete"
                      plain
                      circle
                      size="mini"
                      @click="deleteSampleCart(scope.row)"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="submit_order">
              <div v-if="$i18n.locale === 'en_US'">
                <span
                  ><span>{{ selectedCart }}</span> samples picked</span
                >
                <el-button @click="submitOrder"> Submit </el-button>
              </div>

              <div v-else>
                <span
                  >共选择 <span>{{ selectedCart }}</span> 样商品</span
                >
                <el-button @click="submitOrder"> 提交申请 </el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane key="4" name="样品订单">
          <div slot="label" class="tab-item">
            <span class="el-icon-s-order icon" />
            <span class="text">{{ $t("sampleApply.order.self") }}</span>
          </div>
          <div class="order common_class">
            <sample-order-list />
          </div>
        </el-tab-pane>
      </el-tabs>
    </main>
    <!--<common-footer />-->
  </div>
</template>

<script>
// import CommonHeader from "@/components/CommonHeader";
// import CommonFooter from "@/components/CommonFooter";
import eventBus from "@/utils/eventBus";
import SampleOrderList from "@/views/personal/SampleOrderList";
import UserAddressList from "@/views/personal/UserAddressList";
import router from "@/router";
export default {
  name: "Personal",
  components: { SampleOrderList, UserAddressList },
  data() {
    return {
      // 账户信息
      userId: localStorage.getItem("userId"),
      username: localStorage.getItem("username"),
      // 样品申请
      sampleData: [],
      sampleTotal: 0,
      searchKey: "",
      pageSize: 10,
      num: 0,
      menu: ["账户信息", "样品申请", "我的购物车", "样品订单"],
      selectedTitle: null,
      cartData: [],
      selectedCart: 0,
    };
  },
  watch: {
    $route: {
      handler() {
        this.selectedTitle = this.$route.query.selectedTitle;
        this.initData(this.selectedTitle);
      },
    },
  },
  created() {
    // 用于common-header点击跳转
    this.selectedTitle = this.$route.query.selectedTitle;
    this.initData(this.selectedTitle);
    // 如果未指定，默认第一个
    if (this.selectedTitle == null) {
      this.selectedTitle = this.menu[0];
    }
  },
  methods: {
    handleCommand(Command) {
      this.$router.push({
        name: "Personal",
        query: { selectedTitle: Command.name },
      });
      // this.selectedTitle = Command.name;
      // this.$route.query.selectedTitle = Command.name
      // this.initData(Command.name);
    },
    searchSample() {
      this.listSample(this.searchKey, 1);
    },
    handleCurrentChange(val) {
      this.listSample("", val);
    },
    listSample(searchKey, page) {
      let url = "/item/goodsQuery/loadGoodsByQuery";
      let params = {
        searchKey: searchKey,
        queryMethod: "jdSelectMethod",
        current: page,
        size: 10,
        sampleFlag: true,
      };
      this.$doPost(url, params, true).then((res) => {
        this.sampleData = res.data.records;
        this.sampleTotal = res.data.total;
      });
    },
    addToCart(partNo, num) {
      if (num == null) {
        this.$message(this.$t("sampleApply.sampleApply.validQuantityTips"));
        return;
      }
      let url = "/cart/sample-cart/addSamplesToCart";
      let sampleCarts = [];
      sampleCarts.push({
        partNo: partNo,
        amount: num,
      });
      let param = {
        userId: this.userId,
        sampleCarts: sampleCarts,
      };
      this.$doPost(url, param, true).then((res) => {
        if (res.code == 200) {
          this.$message.success(
            this.$t("sampleApply.sampleApply.toCartSuccess")
          );
          eventBus.$emit("userId", this.userId);
        } else if (res.code == 2000) {
          this.$message.warning(this.$t("sampleApply.sampleApply.cartIsFull"));
        } else {
          this.$message.error(this.$t("sampleApply.sampleApply.toCartFailed"));
        }
      });
    },
    initData(module) {
      switch (module) {
        case "账户信息":
          break;
        case "样品申请":
          this.listSample("", 1);
          break;
        case "我的购物车":
          this.loadUserCart(this.userId);
          break;
        case "样品订单":
          break;
      }
    },
    loadUserCart: function (userId) {
      let url = "/cart/sample-cart/getSampleCartsByUserId";
      let param = {
        userId: userId,
      };
      this.$doPost(url, param).then((res) => {
        if (res.code === 200) {
          this.cartData = res.data;
        } else {
          this.$alert(this.$t("sampleApply.cart.requestCartFailed"));
        }
        this.$nextTick(function () {
          if (this.cartData) {
            //判断有无数据
            this.cartData.forEach((row) => {
              if (row.status == 1) {
                this.$refs.multipleTable.toggleRowSelection(row);
              }
            });
          }
        });
      });
    },
    deleteSampleCart(item) {
      let url = "/cart/sample-cart/deleteSampleCartsByIDs";
      let ids = [];
      ids.push(item.id);
      this.$doPost(url, ids, true).then((res) => {
        if (res.code == 200) {
          this.$message.success(this.$t("common.deleteSuccess"));
        } else {
          this.$message.error(this.$t("common.deleteFailed"));
        }
        this.loadUserCart(this.userId);
        eventBus.$emit("userId", this.userId);
      });
    },
    updateSampleCart(item, batch) {
      let url = "/cart/sample-cart/updateSampleCarts";
      let sampleCarts = [];
      if (batch) {
        sampleCarts.push(...item);
      } else {
        sampleCarts.push(item);
      }
      let params = {
        sampleCarts: sampleCarts,
      };
      this.$doPost(url, params, true).then((res) => {
        if (res.code == 200) {
          console.log("修改成功了");
        } else {
          this.$alert(this.$t("sampleApply.cart.updateFailed"));
        }
      });
    },
    selectChangeCarts(val, row) {
      row.status = (row.status + 1) % 2;
      this.updateSampleCart(row, false);
    },
    selectionLineChangeHandle() {
      console.log(this.$refs.multipleTable.selection);
      this.$nextTick(function () {
        this.selectedCart = this.$refs.multipleTable.selection.length;
      });
    },
    selectAllCarts(rows) {
      console.log(rows.length);
      // 全选中
      if (rows.length > 0) {
        this.cartData.forEach((item) => {
          item.status = 1;
        });
      } else {
        this.cartData.forEach((item) => {
          item.status = 0;
        });
      }
      this.updateSampleCart(this.cartData, true);
    },
    submitOrder() {
      if (this.$refs.multipleTable.selection.length > 0) {
        this.$router.push({
          path: "/preOrder",
          query: {
            goodsList: JSON.stringify(this.$refs.multipleTable.selection),
            userId: this.userId,
          },
        });
      } else {
        this.$message.warning(this.$t("sampleApply.cart.selectGoodsTips"));
      }
    },
  },
};
</script>

<style scoped lang="less">
main {
  background: white;
  text-align: center;
  overflow: hidden;
  font-family: "微软雅黑", "Arial Black", serif;
}
// 头部导航样式
.el-tabs {
  width: 1400px;
  margin: 50px auto;
  .tab-item {
    margin: 0 auto;
    width: fit-content;
    display: flex;
    height: 60px;
    line-height: 60px;
    color: rgb(70, 70, 100);
    span {
      height: 60px;
      line-height: 60px;
      display: inline-block;
      vertical-align: center;
    }
    .icon {
      margin-right: 20px;
      font-size: 30px;
    }
    .text {
      font-weight: bold;
      font-size: 15px;
    }
  }
  /deep/ .el-tabs__item {
    height: 60px;
  }
}

// 表格样式（通用）
div {
  .el-table {
    /deep/ .el-table__cell {
      text-align: center;
    }
    width: 1200px;
    margin: 10px auto 30px auto;
    border: black solid 1px;
    border-radius: 7px;
  }
}
// 样品申请页样式
.spl-title {
  justify-content: center;
  display: flex;
  height: 40px;
  line-height: 40px;
  margin: 60px auto 10px auto;
  .text {
    font-size: 20px;
    margin-right: 10px;
  }
  .num {
    font-size: 35px;
    color: rgb(170, 180, 200);
    font-weight: bold;
  }
}
.search-box {
  .el-input {
    width: 500px;
    margin: 10px 0 50px 0;
  }
}
.el-pagination {
  margin-bottom: 50px;
}
.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}
.common_class {
  margin-bottom: 30px;
}
.submit_order {
  display: flex;
  > div {
    width: 1200px;
    text-align: right;
    margin: 0 auto;
    > span {
      margin-right: 30px;
      > span {
        color: red;
      }
    }
  }
}

.user-address-list {
  text-align: left;
  span {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    margin-left: 87px;
  }
}
.user-basic-info {
  span:first-child {
    text-align: left;
    display: block;
    font-size: 20px;
    font-weight: bold;
    margin-left: 87px;
  }
}
</style>
